export enum VehicleTypes {
    PENDANT = 'pendant',
    DELIVERY_TRUCKS = 'deliveryTrucks',
    TRUCKS_FROM_3_AND_5T = 'lkw3.5t',
    CAR = 'car',
    OTHERS = 'others',
    TRACTOR = 'tractor',
}
